import { createContext, useContext, useEffect, useState } from "react";
import { getAllPlantPos } from "../api";
import { getHashdata } from "../../../../../../../../components/Tabs/Utils/hashFunctions";
import { onGettingPoData } from "./onGettingPoData";
import { useMcsContext } from "../../../MCS.context";

const PoContext = createContext();
export const usePoContext = () => useContext(PoContext);

const initialState = {
  poNumber: "",
  revision: "",
  title: "",
};

function PoContextProvider({ children }) {
  const { plant, setSelectedPoManager } = useMcsContext();

  console.log("plant", plant);
  const [pos, setPos] = useState([]);
  const [selectedPo, setSelectedPo] = useState(initialState);
  const [revisions, setRevisions] = useState([]);
  const [selectionResult, setSelectionResult] = useState({});

  const poId = getHashdata(window.location.hash, "po-id");

  useEffect(() => {
    const showPoByUrl = async () => {
      poId && onGettingPoData({ id: poId, setSelectedPoManager });
    };

    getAllPlantPos(plant?.id, setPos);
    showPoByUrl();
  }, []);

  const onDrawingChange = (po) => {
    setSelectionResult(po);
  };

  const handleNumberChange = (event) => {
    const poNumber = event.target.value;
    setSelectedPo({ ...initialState, poNumber });

    console.log("posss", pos);
    const revs = [
      ...new Set(
        pos
          .filter((d) => d.poNumber === poNumber && d.revision !== "")
          .map((d) => d.revision),
      ),
    ];
    setRevisions(revs);
    // if no revisions, fetch po
    if (!revs[0]) {
      const selectedPo = pos.find((d) => d.poNumber === poNumber);
      onDrawingChange(selectedPo);
    }
  };

  console.log("pos revsss", revisions);

  const handleRevisionChange = (event) => {
    const revision = event.target.value;

    setSelectedPo({ ...selectedPo, revision });

    const x = pos.find(
      (d) => d.poNumber === selectedPo.poNumber && d.revision === revision,
    );

    console.log("posssss:", pos, x);

    setSelectedPo(x);
    onDrawingChange(x);
  };

  const onAddSelectedDrawing = async () => {
    onGettingPoData({ id: selectionResult.id, setSelectedPoManager });
  };
  return (
    <PoContext.Provider
      value={{
        selectedPo,
        handleNumberChange,
        pos,
        handleRevisionChange,
        revisions,
        onAddSelectedDrawing,
      }}
    >
      {children}
    </PoContext.Provider>
  );
}

export { PoContextProvider, PoContext };
